// This function intentionally returns null,
// it is used exclusively for collecting props from storyblok
// This file must remain in place to avoid breaking the imports from the setup script

function KeyValue() {
  return null;
}

export default KeyValue;
